// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Translations} from "@translations";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {EventType} from "@models";

/** eventId is channeled through here, because it is then easier to use with the copyEvent API
 * copyEvent({...result});
 */
export interface DialogData_CopyEventDialogInput extends MatDialogDataBaseInput {
	eventId: string;
	eventType: EventType;
}

export interface DialogData_CopyEventDialogOutput extends MatDialogDataBaseOutput {
	eventId: string;
	newEventName: string;
	newEventDate: Date;
	copyEventDescription: boolean;
	copyParticipants: boolean;
}

@Component({
	selector: "sim-copy-event-dialog",
	templateUrl: "./copy-event-dialog.component.html",
	styleUrls: ["./copy-event-dialog.component.scss"],
	standalone: false,
})
export class CopyEventDialogComponent extends BasicMaterialDialog<
	CopyEventDialogComponent,
	DialogData_CopyEventDialogInput,
	DialogData_CopyEventDialogOutput
> {
	T = Translations;

	public newEvent = new FormGroup({
		newEventName: new FormControl("", Validators.required),
		newEventDate: new FormControl<Date>(null, Validators.required),
		copyEventDescription: new FormControl(false),
		copyParticipants: new FormControl(false),
	});

	constructor(_injector: Injector) {
		super(_injector);

		const today = new Date();
		today.setHours(0, 0, 0, 0);
		this.newEvent.controls.newEventDate.setValue(today);
	}

	cancel() {
		return this.close({
			action: "cancel",
			newEventName: null,
			newEventDate: null,
			eventId: null,
			copyEventDescription: false,
			copyParticipants: false,
		});
	}

	ok() {
		return this.close({
			action: "ok",
			newEventName: this.newEvent.get("newEventName").value,
			newEventDate: this.newEvent.get("newEventDate").value,
			eventId: this.data.eventId,
			copyEventDescription: this.newEvent.get("copyEventDescription").value,
			copyParticipants: this.newEvent.get("copyParticipants").value,
		});
	}

	protected readonly EventType = EventType;
}
